import { SvgIcon, useTheme } from '@lokalise/louis';
import type { SvgIconProps } from '@lokalise/louis';

interface CheckboxIconProps extends SvgIconProps {
    secondaryColor?: string;
}

const CheckboxEmpty = ({ secondaryColor, ...props }: CheckboxIconProps) => {
    const theme = useTheme();

    return (
        <SvgIcon {...props}>
            <rect
                x="3"
                y="3"
                width="14"
                height="14"
                stroke={props.color}
                fill={secondaryColor || theme.color.custom.neutral2}
            />
        </SvgIcon>
    );
};

export default CheckboxEmpty;
